<template>
  <q-card flat bordered>
    <q-card-section>
      <div class="row justify-between">
        <div>
          <div class="text-h6">Email Notifications</div>
          <div>
            Get the latest market information sent to your email, with latest rents, concessions,
            and an Excel export attached.
          </div>
        </div>
        <div class="q-my-auto">
          <q-toggle
            id="intercom-email-toggle"
            v-model="activated"
            dense
            color="primary"
            label="Activate"
            size="lg"
          />
        </div>
      </div>
      <div class="q-mt-md">
        <div id="intercom-email-select">
          <email-select style="margin-top: 20px" :emails="emails" @update-emails="updateEmails" />
        </div>
        <div id="intercom-email-cadence" class="row q-gutter-x-sm q-mt-sm">
          <div class="q-my-auto">Receive a morning email every:</div>
          <q-checkbox
            :model-value="schedule"
            val="Monday"
            label="Monday"
            @update:model-value="newSelection"
          />
          <q-checkbox
            :model-value="schedule"
            val="Tuesday"
            label="Tuesday"
            @update:model-value="newSelection"
          />
          <q-checkbox
            :model-value="schedule"
            val="Wednesday"
            label="Wednesday"
            @update:model-value="newSelection"
          />
          <q-checkbox
            :model-value="schedule"
            val="Thursday"
            label="Thursday"
            @update:model-value="newSelection"
          />
          <q-checkbox
            :model-value="schedule"
            val="Friday"
            label="Friday"
            @update:model-value="newSelection"
          />
          <q-checkbox
            :model-value="schedule"
            val="Saturday"
            label="Saturday"
            @update:model-value="newSelection"
          />
          <q-checkbox
            :model-value="schedule"
            val="Sunday"
            label="Sunday"
            @update:model-value="newSelection"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script lang="ts">
import EmailSelect from '@/components/EmailSelect.vue'

export default {
  name: 'EmailNotifications',
  components: { EmailSelect },
  props: {
    emails: {
      type: Array<string>,
      default: []
    },
    schedule: {
      type: Array<string>,
      required: true
    }
  },
  emits: ['update-emails', 'update-schedule'],
  data() {
    return {
      daysOfWeek: {
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        Sunday: 7
      } as { [key: string]: number }
    }
  },
  computed: {
    user() {
      return this.$auth0.user.value
    },
    activated: {
      get() {
        return this.emails.length > 0 && this.schedule.length > 0
      },
      set(value: boolean) {
        if (value) {
          this.$emit('update-schedule', ['Monday'])
          if (this.user.email) {
            this.$emit('update-emails', [this.user.email])
          } else {
            throw new Error('User email not found')
          }
        } else {
          this.$emit('update-schedule', [])
        }
      }
    }
  },
  methods: {
    updateEmails(emails: string[]) {
      this.$emit('update-emails', emails)
    },
    newSelection(values: string[]) {
      values.sort((a, b) => {
        return this.daysOfWeek[a] - this.daysOfWeek[b]
      })
      this.$emit('update-schedule', values)
    }
  }
}
</script>
